import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { mijnTegoed } from "@/lib/vakman.functions";
import { VakmanPoort, euro } from "@/components/vakman";
import { LEAD_PRIJS } from "@/lib/vakman-shared";

export const Route = createFileRoute("/vakman/tegoed")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Tegoed | Vakmanportaal offerto" },
      { name: "description", content: "Bekijk je tegoed en ontgrendelde aanvragen." },
      { property: "og:title", content: "Tegoed | Vakmanportaal" },
      { property: "og:description", content: "Je tegoed in het vakmanportaal." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <VakmanPoort>{({ saldo }) => <Tegoed saldo={saldo} />}</VakmanPoort>,
});

function Tegoed({ saldo }: { saldo: number }) {
  const haal = useServerFn(mijnTegoed);
  const { data } = useQuery({ queryKey: ["vakman-tegoed"], queryFn: () => haal() });
  return (
    <div className="space-y-4">
      <Link to="/vakman" className="inline-block rounded-md border border-border bg-background px-4 py-2 font-bold">Terug</Link>
      <div className="rounded-xl border border-border bg-background p-6">
        <h1 className="text-2xl font-bold">Tegoed: {euro(saldo)}</h1>
        <p className="mt-2 text-muted-foreground">Elke ontgrendelde aanvraag kost {euro(LEAD_PRIJS)}. Goedgekeurde reclamaties krijg je terug op je tegoed.</p>
        <div className="mt-4 rounded-lg bg-secondary p-4 text-sm">
          Online opwaarderen komt binnenkort. Wil je nu tegoed? Neem contact op via info@elvion-group.nl, dan zetten we het voor je klaar.
        </div>
      </div>
      <div className="rounded-xl border border-border bg-background p-6">
        <h2 className="text-lg font-bold">Overzicht</h2>
        {(data ?? []).length === 0 && <p className="mt-2 text-muted-foreground">Nog geen boekingen.</p>}
        <ul className="mt-2 divide-y divide-border">
          {(data ?? []).map((m) => (
            <li key={m.id} className="flex justify-between gap-3 py-2.5">
              <span>{m.omschrijving ?? m.soort}<span className="block text-xs text-muted-foreground">{new Date(m.created_at).toLocaleString("nl-NL")}</span></span>
              <span className={`font-bold ${m.bedrag < 0 ? "text-destructive" : "text-primary"}`}>{m.bedrag > 0 ? "+" : ""}{euro(m.bedrag)}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
